import { render, staticRenderFns } from "./CancellationPolicy.vue?vue&type=template&id=ff896cbc&scoped=true"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js"
import style0 from "./CancellationPolicy.vue?vue&type=style&index=0&id=ff896cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff896cbc",
  null
  
)

export default component.exports